class ScrollManager {
  constructor() {
    this.allowScroll = undefined;
    this.scrollTop = 0;
    this.overlayElement = null;
  }

  preventOverlayOverscroll() {
    if (!this.overlayElement) return;

    const top = this.overlayElement.scrollTop;
    const totalScroll = this.overlayElement.scrollHeight;
    const currentScroll = top + this.overlayElement.clientHeight;

    if (top === 0) {
      this.overlayElement.scrollTop = 1;
    } else if (currentScroll === totalScroll) {
      this.overlayElement.scrollTop = top - 1;
    }
  }

  shouldScrollOverlay() {
    if (this.overlayElement && this.overlayElement.clientHeight < this.overlayElement.scrollHeight) {
      this.allowScroll = true;
    }
  }

  preventBodyScroll(e) {
    if (!this.allowScroll) {
      e.preventDefault();
    }
  }

  preventScroll(el) {
    this.overlayElement = el;
    const body = document.body;
    const scrollbarWidth = window.innerWidth - body.clientWidth;

    document.querySelectorAll("[data-scrollbar-offset]").forEach(el => {
      el.style.paddingRight = `${scrollbarWidth}px`;
    });

    this.scrollTop = window.scrollY;

    body.style.overflow = "hidden";

    this.overlayElement.addEventListener("touchstart", this.preventOverlayOverscroll.bind(this));
    this.overlayElement.addEventListener("touchmove", this.shouldScrollOverlay.bind(this));
    body.addEventListener("touchmove", this.preventBodyScroll.bind(this));
  }

  enableScroll() {
    document.querySelectorAll("[data-scrollbar-offset]").forEach(el => {
      el.style.paddingRight = "0px";
    });

    window.scrollTo(0, this.scrollTop);
    document.body.style.overflow = "auto";

    this.allowScroll = undefined;
    document.body.removeEventListener("touchmove", this.preventBodyScroll.bind(this));
    if (this.overlayElement) {
      this.overlayElement.removeEventListener("touchmove", this.shouldScrollOverlay.bind(this));
      this.overlayElement.removeEventListener("touchstart", this.preventOverlayOverscroll.bind(this));
    }
  }
}

window.MoMA.ScrollManager = new ScrollManager();
